// Authentication Routes
import Login from "../app/auth/login";
import JoinUs from "../app/auth/joinUs";

// Supplier routes
import SupplierClients from "../app/supplierDashboard/clients";
import SupplierDashboard from "../app/supplierDashboard/dashboard";
import SupplierAddEditProducts from "../app/supplierDashboard/products";
import SupplierSettings from "../app/supplierDashboard/setting";
import SupplierCustomerSupport from "./../app/supplierDashboard/customorSupport/index";
import SupplierSubscription from "../app/supplierDashboard/subscription";
import SupplierCatalogue from "../app/supplierDashboard/order";

import RegisterAsSupplier from "../app/auth/signup/supplier";
import SupplierRegistrationVerification from "../app/auth/verification/SupplierRegVerification";

// Worker Routes
import WorkerDashboard from "../app/workerDashboard/dashboard";
import WorkerReports from "../app/workerDashboard/report";
import WorkerReviews from "../app/workerDashboard/reviews";
import WorkerAccountSetting from "../app/workerDashboard/setting";
import WorkerAppointment from "../app/workerDashboard/workerAppointments";
import { allIcons } from "../assets";
import CompanyDashbaord from "../app/companyDashboard/dashboard";
import CompanyWorkerAndClients from "../app/companyDashboard/workersAndClients";
import CompanySubscription from "../app/companyDashboard/subscription";
import CompanyCustomerSupport from "../app/companyDashboard/customerSupport";
import CompanySettings from "../app/companyDashboard/setting";
import CompanyCatalogue from "../app/companyDashboard/catalogue";
import CompanyWorkersShift from "../app/companyDashboard/companyAppointments";
import EducationDashbaord from "../app/educationDashbaord/dashboard";
import EducationAdmission from "../app/educationDashbaord/addmissions";
import EducationClasses from "../app/educationDashbaord/classes";
import EducationStudent from "../app/educationDashbaord/student";
import EducationSetting from "../app/educationDashbaord/setting";
import EducationTimeTable from "../app/educationDashbaord/timeTable";
import EducationReportCard from "../app/educationDashbaord/reportCard";
import ForgotPassword from "./../app/auth/forgot/index";
import Forgotverification from "../app/auth/forgot/ForgotVerification";
import RegisterAsCompany from "../app/auth/signup/company";
import CompanyRegistrationVerification from "../app/auth/verification/CompanyRegVerification";
import PurchaseSubscription from "../app/auth/purchaseSubscription";
import AllServices from "../app/auth/purchaseSubscription/AllServices";
import RegisterAsWorker from "../app/auth/signup/worker";
import WorkerRegistrationVerification from "../app/auth/verification/WorkerRegVerification";
import WorkerServices from "../app/auth/signup/worker/AllServices";
import CompanyReports from "../app/companyDashboard/report";
import WorkerSubscription from "../app/workerDashboard/subscription";
import WorkerCustomerSupport from "../app/workerDashboard/customorSupport";
import Notifications from "../app/common/notifications";
import WorkerSchedule from "../app/workerDashboard/shedule";
import WorkerShedule from "../app/auth/signup/worker/Shedule";
import RegisterAsCreator from "../app/auth/signup/creator";
import CompanyProfileType from "../app/auth/profileType";
import CreatorRegistrationVerification from "../app/auth/verification/CreatorRegVerfication";
import CreatorDashboard from "../app/creatorDashboard/dashboard";
import CreatorCustomerSupport from "../app/creatorDashboard/customerSupport";
import CreatorSettings from "../app/creatorDashboard/setting";
import CreatorOnboarding from "../app/creatorDashboard/onboarding";
import CreatorCampaigns from "../app/creatorDashboard/campaigns";

const AuthRoutes = [
  {
    id: 1,
    name: "Join Us",
    component: <JoinUs />,
    path: "/",
    icon: "location_on",
  },
  {
    id: 2,
    name: "Login",
    component: <Login />,
    path: "/login",
    icon: "location_on",
  },
  {
    id: 3,
    name: "Company Profile Type",
    component: <CompanyProfileType />,
    path: "/company/profile-type",
    icon: "location_on",
  },
  {
    id: 3,
    name: "Register As Supplier",
    component: <RegisterAsSupplier />,
    path: "/register/supplier",
    icon: "location_on",
  },
  {
    id: 4,
    name: "Register As Creator",
    component: <RegisterAsCreator />,
    path: "/register/creator",
    icon: "location_on",
  },
  {
    id: 4,
    name: "Registeration verification",
    component: <SupplierRegistrationVerification />,
    path: "/register/supplier/verification",
    icon: "location_on",
  },
  {
    id: 5,
    name: "Register As Company",
    component: <RegisterAsCompany />,
    path: "/register/company",
    icon: "location_on",
  },
  {
    id: 6,
    name: "Registeration verification",
    component: <CompanyRegistrationVerification />,
    path: "/register/company/verification",
    icon: "location_on",
  },
  {
    id: 7,
    name: "Register As Worker",
    component: <RegisterAsWorker />,
    path: "/register/worker",
    icon: "location_on",
  },
  {
    id: 8,
    name: "Registeration verification",
    component: <WorkerRegistrationVerification />,
    path: "/register/worker/verification",
    icon: "location_on",
  },
  {
    id: 9,
    name: "Registeration verification",
    component: <CreatorRegistrationVerification />,
    path: "/register/creator/verification",
    icon: "location_on",
  },
  {
    id: 9,
    name: "Forgot Password",
    component: <ForgotPassword />,
    path: "/forgot-password",
    icon: "location_on",
  },

  {
    id: 10,
    name: "Forgot Password",
    component: <Forgotverification />,
    path: "/forgot-password/verify",
    icon: "location_on",
  },
  {
    id: 11,
    name: "Purchase Subscription",
    component: <PurchaseSubscription />,
    path: "/subscriptions",
    icon: "location_on",
  },
  {
    id: 12,
    name: "Select All Service",
    component: <AllServices />,
    path: "/select-service",
    icon: "location_on",
  },
  {
    id: 12,
    name: "Select All Service",
    component: <WorkerServices />,
    path: "/register/worker/services",
    icon: "location_on",
  },
  {
    id: 13,
    name: "Worker Shedule",
    component: <WorkerShedule />,
    path: "/worker/shedule/:workerId/:type",
    icon: "location_on",
  },
];

// Supplier routes
const SupplierRoutes = [
  {
    id: 1,
    name: "dashboard",
    component: <SupplierDashboard />,
    path: "/supplier/dashboard",
    icon: allIcons.dasboardInactice,
    iconActive: allIcons.dasboardActice,
  },
  {
    id: 3,
    name: "allSales",
    component: <SupplierCatalogue />,
    path: "/supplier/sale",
    icon: allIcons.bookopenInactive,
    iconActive: allIcons.bookopenActive,
  },
  {
    id: 3,
    name: "products",
    component: <SupplierAddEditProducts />,
    path: "/supplier/add-Products",
    icon: allIcons.handshakeInactiveIcon,
    iconActive: allIcons.handshakeActiveIcon,
  },
  // {
  //   id: 4,
  //   name: "clients",
  //   component: <SupplierClients />,
  //   path: "/supplier/clients",
  //   icon: allIcons.smileyInactive,
  //   iconActive: allIcons.smileyActive,
  // },
  {
    id: 5,
    name: "support",
    component: <SupplierCustomerSupport />,
    path: "/supplier/customer-support",
    icon: allIcons.handshakeInactiveIcon,
    iconActive: allIcons.handshakeActiveIcon,
  },

  {
    id: 6,
    name: "subscriptions",
    component: <SupplierSubscription />,
    path: "/supplier/subscription",
    icon: allIcons.packageIconInactive,
    iconActive: allIcons.packageIconActive,
  },
  {
    id: 7,
    name: "notifications",
    component: <Notifications />,
    path: "/supplier/notifications",
    icon: allIcons.notificationInactive,
    iconActive: allIcons.notificationActive,
  },
  {
    id: 7,
    name: "settings",
    component: <SupplierSettings />,
    path: "/supplier/settings",
    icon: allIcons.settingInactiveIcon,
    iconActive: allIcons.settingActiveIcon,
  },
];

// Worker routes
const WorkerRoutes = [
  {
    id: 1,
    name: "dashboard",
    component: <WorkerDashboard />,
    path: "/worker/dashboard",
    icon: allIcons.dasboardInactice,
    iconActive: allIcons.dasboardActice,
  },
  {
    id: 1,
    name: "calendar",
    component: <WorkerAppointment />,
    path: "/worker/calendar",
    icon: allIcons.calenderCheckIcon,
    iconActive: allIcons.calendarWhiteIcon,
  },
  {
    id: 3,
    name: "reviews",
    component: <WorkerReviews />,
    path: "/worker/reviews",
    icon: allIcons.smileyInactive,
    iconActive: allIcons.smileyActive,
  },
  {
    id: 4,
    name: "report",
    component: <WorkerReports />,
    path: "/worker/report",
    icon: allIcons.reportIconInactive,
    iconActive: allIcons.reportIconActive,
  },
  {
    id: 5,
    name: "liveSupport",
    component: <WorkerCustomerSupport />,
    path: "/worker/customer-support",
    icon: allIcons.handshakeInactiveIcon,
    iconActive: allIcons.handshakeActiveIcon,
  },

  {
    id: 6,
    name: "subscriptions",
    component: <WorkerSubscription />,
    path: "/worker/subscription",
    icon: allIcons.packageIconInactive,
    iconActive: allIcons.packageIconActive,
  },
  {
    id: 7,
    name: "notifications",
    component: <Notifications />,
    path: "/worker/notifications",
    icon: allIcons.notificationInactive,
    iconActive: allIcons.notificationActive,
  },
  {
    id: 7,
    name: "schedule",
    component: <WorkerSchedule />,
    path: "/worker/schedule",
    icon: allIcons.calenderCheckIcon,
    iconActive: allIcons.calendarWhiteIcon,
  },
  {
    id: 8,
    name: "settings",
    component: <WorkerAccountSetting />,
    path: "/worker/settings",
    icon: allIcons.settingInactiveIcon,
    iconActive: allIcons.settingActiveIcon,
  },
];

const CompanyRoutes = [
  {
    id: 1,
    name: "dashboard",
    component: <CompanyDashbaord />,
    path: "/company/dashboard",
    icon: allIcons.dasboardInactice,
    iconActive: allIcons.dasboardActice,
  },
  {
    id: 2,
    name: "shift",
    component: <CompanyWorkersShift />,
    path: "/company/shift",
    icon: allIcons.calenderCheckIcon,
    iconActive: allIcons.calendarWhiteIcon,
  },
  {
    id: 3,
    name: "workersClients",
    component: <CompanyWorkerAndClients />,
    path: "/company/workers-clients",
    icon: allIcons.smileyInactive,
    iconActive: allIcons.smileyActive,
  },
  {
    id: 4,
    name: "catalogue",
    component: <CompanyCatalogue />,
    path: "/company/catalogue",
    icon: allIcons.bookopenInactive,
    iconActive: allIcons.bookopenActive,
  },
  {
    id: 5,
    name: "report",
    component: <CompanyReports />,
    path: "/company/report",
    icon: allIcons.reportIconInactive,
    iconActive: allIcons.reportIconActive,
  },

  {
    id: 6,
    name: "liveSupport",
    component: <CompanyCustomerSupport />,
    path: "/company/customer-support",
    icon: allIcons.handshakeInactiveIcon,
    iconActive: allIcons.handshakeActiveIcon,
  },
  {
    id: 7,
    name: "notifications",
    component: <Notifications />,
    path: "/company/notifications",
    icon: allIcons.notificationInactive,
    iconActive: allIcons.notificationActive,
  },
  {
    id: 8,
    name: "subscriptions",
    component: <CompanySubscription />,
    path: "/company/subscription",
    icon: allIcons.packageIconInactive,
    iconActive: allIcons.packageIconActive,
  },
  {
    id: 9,
    name: "settings",
    component: <CompanySettings />,
    path: "/company/settings",
    icon: allIcons.settingInactiveIcon,
    iconActive: allIcons.settingActiveIcon,
  },
];

const EducationRoutes = [
  {
    id: 1,
    name: "Dashboard",
    component: <EducationDashbaord />,
    path: "/education/dashboard",
    icon: allIcons.dasboardInactice,
    iconActive: allIcons.dasboardActice,
  },
  {
    id: 2,
    name: "Admissions",
    component: <EducationAdmission />,
    path: "/education/admissions",
    icon: allIcons.admissionBlackIcon,
    iconActive: allIcons.admissionWhiteIcon,
  },
  {
    id: 3,
    name: "Classes",
    component: <EducationClasses />,
    path: "/education/classes",
    icon: allIcons.classBlackIcon,
    iconActive: allIcons.classWhiteIcon,
  },
  {
    id: 4,
    name: "Students",
    component: <EducationStudent />,
    path: "/education/students",
    icon: allIcons.studentInActiveIcon,
    iconActive: allIcons.studentActiveIcon,
  },
  {
    id: 5,
    name: "Time Table",
    component: <EducationTimeTable />,
    path: "/education/time-table",
    icon: allIcons.timeTableBlackIcon,
    iconActive: allIcons.timeTableWhiteIcon,
  },
  {
    id: 6,
    name: "Reports & Cards",
    component: <EducationReportCard />,
    path: "/education/report-card",
    icon: allIcons.notificationInactive,
    iconActive: allIcons.notificationActive,
  },
  {
    id: 7,
    name: "Settings",
    component: <EducationSetting />,
    path: "/education/settings",
    icon: allIcons.settingInactiveIcon,
    iconActive: allIcons.settingActiveIcon,
  },
];

const supplierSubscriptionRoute = [
  {
    id: 5,
    name: "subscriptions",
    component: <SupplierSubscription />,
    path: "/supplier/subscription",
    icon: allIcons.packageIconInactive,
    iconActive: allIcons.packageIconActive,
  },
];

const CreatorRoutes = [
  {
    id: 1,
    name: "dashboard",
    component: <CreatorDashboard />,
    path: "/creator/dashboard",
    icon: allIcons.dasboardInactice,
    iconActive: allIcons.dasboardActice,
  },
  {
    id: 4,
    name: "campaigns",
    component: <CreatorCampaigns />,
    path: "/creator/campaigns",
    icon: allIcons.packageIconInactive,
    iconActive: allIcons.packageIconActive,
  },
  {
    id: 5,
    name: "notifications",
    component: <Notifications />,
    path: "/creator/notifications",
    icon: allIcons.notificationInactive,
    iconActive: allIcons.notificationActive,
  },
  {
    id: 2,
    name: "support",
    component: <CreatorCustomerSupport />,
    path: "/creator/customer-support",
    icon: allIcons.handshakeInactiveIcon,
    iconActive: allIcons.handshakeActiveIcon,
  },
  {
    id: 3,
    name: "settings",
    component: <CreatorSettings />,
    path: "/creator/settings",
    icon: allIcons.settingInactiveIcon,
    iconActive: allIcons.settingActiveIcon,
  },
];

// Creator routes while account is pending review or rejected
const CreatorOnboardingRoutes = [
  {
    id: 1,
    name: "onboarding",
    component: <CreatorOnboarding />,
    path: "/creator/onboarding",
    icon: allIcons.dasboardInactice,
    iconActive: allIcons.dasboardActice,
  },
  {
    id: 2,
    name: "support",
    component: <CreatorCustomerSupport />,
    path: "/creator/customer-support",
    icon: allIcons.handshakeInactiveIcon,
    iconActive: allIcons.handshakeActiveIcon,
  },
  {
    id: 3,
    name: "settings",
    component: <CreatorSettings />,
    path: "/creator/settings",
    icon: allIcons.settingInactiveIcon,
    iconActive: allIcons.settingActiveIcon,
  },
];

export {
  AuthRoutes,
  CreatorOnboardingRoutes,
  SupplierRoutes,
  WorkerRoutes,
  CompanyRoutes,
  EducationRoutes,
  supplierSubscriptionRoute,
  CreatorRoutes,
};
